import React from "react";

const InvalidLinkPage = ({ message }) => {
  return (
    <div>
      <h2>Invalid Link</h2>
      <p>{message}</p>
      <p>Please contact support or visit our homepage for more information.</p>
    </div>
  );
};

export default InvalidLinkPage;
